export const SET_LOADING = 'SET_LOADING';

export const setLoading = (loading: boolean) => ({
    loading,
    type: SET_LOADING,
});

export const initialState = false;

export default (state = initialState, action: any) => {
    switch (action.type) {
        case SET_LOADING: {
            return action.loading;
        }
        default:
            return state;
    }
};
